import { CoreTokenTypes } from './tokens';
import { getFinalRollConfig } from './util/rollConfig';
function createRollDice(plugins, config) {
    function rollDice(tokens, configOverrides) {
        var finalConfig = getFinalRollConfig(config, configOverrides);
        return tokens.map(function (token) {
            switch (token.type) {
                case CoreTokenTypes.CloseParen:
                case CoreTokenTypes.OpenParen:
                case CoreTokenTypes.Operator:
                    return null;
                case CoreTokenTypes.DiceRoll:
                    return plugins[token.detailType].roll(token.detail, finalConfig);
            }
        });
    }
    return rollDice;
}
export default createRollDice;
